module.exports = __webpack_public_path__ + "media/images/icon__reddit-dd5813e319340e6097b78bbcf7d9b1b5.png";